import styled from "@emotion/styled";
import { IStyledComponentProps } from "../../theme/theme.types";

const ClickSheild = styled.div<IStyledComponentProps>`
  &.click-shield {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: black;
    height: 100%;
    width: 100%;
    z-index: 1000;
    opacity: 0;
    display: none;
  }
`;

const DrawerContainter = styled.div<IStyledComponentProps>`
  &.drawer-container {
    background-color: ${(props) => props.theme?.colors?.grays?.quaternary};
    height: 100%;
    overflow: hidden;
    position: absolute;
    right: 0;
    -webkit-transform: translateX(
      ${(props) => props.theme?.layoutProperties?.outageDrawerWidth}px
    );
    transform: translateX(
      ${(props) => props.theme?.layoutProperties?.outageDrawerWidth}px
    );
    z-index: 2000;
    width: ${(props) =>
      props.theme.utils.browserUtils.isMobileSafari
        ? "30%"
        : props.theme?.layoutProperties?.outageDrawerWidth + "px"};

    &.mobile {
      position: fixed; // @todo: Keep an eye on this, we may need to adjust for mobile browsers
      width: 100%;
      left: 0;
      right: 0;
      top: 75px;
      bottom: 0;
      transform: translateY(100vh);
      overflow-y: scroll;
    }
    .drawer-submit-button {
      color: ${({ theme }) => theme.colors?.essential.buttonGreen};
    }
  }
`;

const DrawerHeader = styled.div<IStyledComponentProps>`
  &.drawer-header {
    align-items: center;
    background-color: ${(props) => props.theme?.colors?.brand?.secondary};
    display: flex;
    font-family: ${(props) => props.theme?.fontFamilies?.regular};
    height: 60px;
    position: fixed;
    width: 100%;

    .title-container {
      flex: auto;
      h1 {
        color: ${(props) => props.theme?.colors?.essential?.white};
        font-size: ${(props) => props.theme?.fontSizes?.small}px;
        text-align: center;
        margin-bottom: 0;
        padding-left: 60px;
        &.search-mode {
          padding-left: 0;
        }
      }
    }

    .close-button-container {
      width: 60px;
      height: 60px;
      border-left: 1px solid ${(props) => props.theme?.colors?.essential?.white};
      button {
        appearance: none;
        background: none;
        border: 0 none;
        color: ${(props) => props.theme?.colors?.essential?.white};
        padding: 6px 10px 0;
        transition: all 250ms linear;

        &:hover {
          transform: scale(1.1);
        }

        .close-button-label {
          display: block;
          font-size: ${(props) => props.theme?.utils?.decreaseFontSize(5)};
          margin-top: 2px;
        }
      }
    }

    .back-button-container {
      width: 60px;
      height: 60px;
      border-right: 1px solid
        ${(props) => props.theme?.colors?.essential?.white};
      text-align: center;
      button {
        appearance: none;
        background: none;
        border: 0 none;
        color: ${(props) => props.theme?.colors?.essential?.white};
        padding: 6px 10px 0;
        transition: all 250ms linear;

        svg {
          margin-bottom: 4px;
        }

        &:hover {
          transform: scale(1.1);
        }

        .close-button-label {
          display: block;
          font-size: ${(props) => props.theme?.utils?.decreaseFontSize(5)};
          margin-top: 2px;
        }
      }
    }
  }
`;

export default {
  ClickSheild,
  DrawerContainter,
  DrawerHeader,
};
